import { i18n } from "services/i18nService";

import { OBJECT_TYPES } from "appConstants";

export const SETTINGS = [
  {
    apiName: "autoBuildShipment",
    component: "FrmCheckbox",
  },
  {
    apiName: "shipmentNumber",
    component: "FrmTransactionNumber",
    transactionType: OBJECT_TYPES.SHIPMENT.fullString,
    hasInputLabel: true,
  },
  {
    apiName: "packingSlipText",
    component: "FrmTextField",
    maxLength: 50,
  },
  {
    apiName: "replyEmailPS",
    component: "FrmTextField",
    maxLength: 255,
  },
  {
    apiName: "packingSlipEmail",
    component: "FrmResizeTextField",
    explanationOverride: (
      <>
        {i18n("settings.fulfillment.shipments.packingSlipEmail.explanation.1")}
        <p>
          {i18n(
            "settings.fulfillment.shipments.packingSlipEmail.explanation.2"
          )}
        </p>
        <div>
          {i18n(
            "settings.fulfillment.shipments.packingSlipEmail.explanation.3"
          )}
        </div>
        <div>
          {i18n(
            "settings.fulfillment.shipments.packingSlipEmail.explanation.4"
          )}
        </div>
        <div>
          {i18n(
            "settings.fulfillment.shipments.packingSlipEmail.explanation.5"
          )}
        </div>
      </>
    ),
  },
  {
    apiName: "packingSlipFooter",
    component: "FrmResizeTextField",
  },
  {
    apiName: "showCustEmailOnPackingSlip",
    component: "FrmCheckbox",
  },
  {
    apiName: "showCustPhoneOnPackingSlip",
    component: "FrmCheckbox",
  },
  {
    apiName: "shipFromAddressOfLocation",
    component: "FrmCheckbox",
  },

  {
    apiName: "defaultCCShipment",
    component: "FrmTextField",
    maxLength: 255,
  },
  {
    apiName: "showWarrantyOnPackingSlip",
    component: "FrmCheckbox",
  },
];
